import { motion } from 'motion/react';
import { ChevronRight } from 'lucide-react';
import { PercentageBadge } from './PercentageBadge';

interface HabitCardProps {
  title: string;
  category: string;
  gain: string;
  gainType?: 'positive' | 'negative' | 'neutral';
  onClick?: () => void;
}

export function HabitCard({ title, category, gain, gainType = 'positive', onClick }: HabitCardProps) {
  return (
    <motion.button
      whileTap={{ scale: 0.97 }}
      onClick={onClick}
      className="w-full bg-white p-6 rounded-[2rem] shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-stone-100 flex items-center justify-between text-left transition-all hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] hover:border-stone-200 group relative overflow-hidden"
    >
      {/* Subtle hover background slide effect */}
      <span className="absolute inset-0 bg-stone-50/50 translate-y-full transition-transform duration-500 ease-[0.25,1,0.5,1] group-hover:translate-y-0 -z-10" />
      
      <div className="flex flex-col gap-1.5 z-10">
        <h3 className="text-[1.15rem] font-bold text-stone-900 tracking-tight">{title}</h3>
        <p className="text-sm font-medium text-stone-500">{category}</p>
      </div>
      
      <div className="flex items-center gap-4 z-10">
        <PercentageBadge value={gain} type={gainType} />
        <div className="bg-stone-50 p-2 rounded-full group-hover:bg-white transition-colors border border-transparent group-hover:border-stone-100">
          <ChevronRight className="w-4 h-4 text-stone-400 group-hover:text-stone-700 transition-colors" strokeWidth={3} />
        </div>
      </div>
    </motion.button>
  );
}
